module.exports = {
  nonWriteoffList: 'รายการที่ยังไม่ได้ชำระ',
  writeoffList: 'ค้นหาการชำระเงิน',
  selectHedgingTheInvoice: 'กรุณาค้นหาและเลือกรายการที่จะหักลบ',
  return: 'กลับ',
  query: 'ค้นหา',
  writeOffs: 'ชำระเงิน',
  confirm: 'ยืนยัน',
  hedgingWriteOffs: 'การชำระเงินแบบหักลบ',
  actualReceiptAndPayment: 'รับจริงจ่ายจริง',
  revenueAndExpenditureMethod: 'วิธีการรับจ่าย',
  all: 'ทั้งหมด',
  receivables: 'ต้องรับ',
  payables: 'ต้องจ่าย',
  feeType: 'ประเภทค่าใช้จ่าย:',
  domestic: 'ในประเทศ',
  international: 'ต่างประเทศ',
  writeOffMode: 'โหมดการชำระเงิน',
  charges: 'ค่าใช้จ่าย',
  invoice: 'ใบแจ้งหนี้',
  bill: 'บิล',
  accountStatement: 'ใบแจ้งยอด',
  paymentRequest: 'คำขอชำระเงิน',
  revenueAndExpenditureDate: 'วันที่รับจ่าย',
  writeOffSerialNumber: 'เลขที่อ้างอิงการชำระเงิน',
  settleAccountsTo: 'ผู้รับการชำระเงิน',
  chargeRemark: 'หมายเหตุค่าใช้จ่าย',
  applyState: 'สถานะคำขอ',
  applicationNo: 'เลขที่คำขอ',
  businessNumber: 'เลขที่ธุรกรรม',
  theOppositeSideInvoiceNo: 'เลขที่ใบแจ้งหนี้ของคู่กรณี',
  consignationCompany: 'หน่วยงานที่มอบหมาย',
  settlementAgent: 'ตัวแทนชำระเงิน',
  currency: 'สกุลเงิน',
  applicant: 'ผู้ยื่นคำขอ',
  businessType: 'ประเภทธุรกรรม',
  dateOfApplication: 'วันที่ยื่นคำขอ',
  businessDate: 'วันที่ทำธุรกรรม',
  operation: 'ดำเนินการ',
  sales: 'การขาย',
  wroteOffOrNot: 'ได้รับการตรวจสอบแล้วหรือไม่',
  businessReferenceNumber: 'เลขที่อ้างอิงธุรกรรม',
  businessStatus: 'สถานะธุรกรรม',
  separateNumber: 'เลขที่ใบแยก',
  paymentNotificationNo: 'เลขที่แจ้งชำระเงิน',
  applicationDepartment: 'หน่วยงานที่ยื่นคำขอ',
  paymentPeriod: 'ระยะเวลาชำระเงิน',
  amount: 'จำนวนเงิน',
  theAmountOfWriteOffs: 'จำนวนเงินที่ตรวจสอบ',
  approvalStatus: 'สถานะการอนุมัติ',
  businessAuditor: 'ผู้ตรวจสอบธุรกรรม',
  businessAuditDate: 'เวลาตรวจสอบธุรกิจ',
  departmentAuditor: 'ผู้ตรวจสอบฝ่าย',
  departmentAuditDate: 'เวลาตรวจสอบฝ่าย',
  officeAuditor: 'ผู้ตรวจสอบธุรกิจ',
  officeAuditDate: 'เวลาตรวจสอบธุรกิจ',
  financialAuditor: 'ผู้ตรวจสอบการเงิน',
  financialAuditDate: 'เวลาตรวจสอบการเงิน',
  financeVerifyDate: 'วันที่ตรวจสอบการเงิน',
  verificationStatus: 'สถานะการตัดจ่าย',
  remark: 'หมายเหตุ',
  totalAmountNtWrittenOff: 'ยอดรวมที่ยังไม่ได้ตัดจ่าย',
  methodOfPayment: 'วิธีการชำระเงิน',
  claimState: 'สถานะการรับรู้',
  prePayment: 'เป็นเงินล่วงหน้าหรือไม่',
  lastTimeBalance: 'ยอดคงเหลือครั้งก่อน',
  thisTimeWriteOff: 'การตัดจ่ายครั้งนี้',
  thisTimeBalance: 'ยอดคงเหลือครั้งนี้',
  otherCurrency: 'สกุลเงินอื่น',
  paymentMethod: 'วิธีการรับเงิน',
  bankReceiptStatus: 'สถานะใบเสร็จ',
  ourSideBank: 'ธนาคารฝ่ายเรา',
  ourSideAccount: 'บัญชีฝ่ายเรา',
  proofNo: 'เลขที่เอกสาร',
  usePaymentRecord: 'บันทึกการใช้เงิน',
  paymentAmount: 'จำนวนเงินที่จ่าย',
  receiptAmount: 'จำนวนเงินที่รับ',
  theOppositeSideCompany: 'หน่วยงานคู่กรณี',
  theOppositeSideBank: 'ธนาคารคู่กรณี',
  theOppositeSideAccount: 'บัญชีคู่กรณี',
  exchangeGainsAndLosses: 'กำไรขาดทุนจากการแลกเปลี่ยน',
  financialCharges: 'ค่าใช้จ่ายทางการเงิน',
  oddment: 'เงินทอนขาด',
  originalCurrencyExchangeDifference: 'ส่วนต่างอัตราแลกเปลี่ยนสกุลเงินเดิม',
  writeOffRemarks: 'หมายเหตุการตัดจ่าย',
  paymentReceivedDate: 'วันที่รับเงิน',
  paymentDate: 'วันที่จ่ายเงิน',
  confirmToWriteOff: 'ยืนยันการตัดจ่าย',
  cancel: 'ยกเลิก',
  totalGainsAndLosses: 'สรุปกำไรขาดทุน',
  date: 'วันที่',
  method: 'วิธีการ',
  use: 'ใช้',
  cancelUsed: 'ยกเลิกการใช้',
  record: 'บันทึก',
  chargeItem: 'ชื่อค่าใช้จ่าย',
  reconciliationStatus: 'สถานะการตรวจสอบบัญชี',
  type: 'ประเภท',
  writeOffExchangeRate: 'อัตราแลกเปลี่ยนในการตัดจ่าย',
  total: 'รวมทั้งหมด',
  confirmedCharge: 'ค่าใช้จ่ายที่ยืนยันแล้ว',
  subTotal: 'ยอดรวมย่อย',
  invoiceNo: 'เลขที่ใบแจ้งหนี้',
  invoiceHeader: 'ชื่อในใบแจ้งหนี้',
  invoiceDate: 'วันที่ออกใบแจ้งหนี้',
  revenueAndExpenditureType: 'ประเภทการรับ/จ่าย',
  billNo: 'เลขที่บิล',
  accountStatementNo: 'เลขที่ใบแจ้งยอด',
  billType: 'ประเภทบิล',
  useReceiptRecord: 'ใช้บันทึกรายการรับเงิน',
  cancelUsedReceiptRecord: 'ยกเลิกการใช้บันทึกรายการรับเงิน',
  cancelUsedPaymentRecord: 'ยกเลิกการใช้บันทึกรายการจ่ายเงิน',
  mbl: 'เลขที่เอกสารหลัก',
  itemNo: 'เลขที่โครงการ',
  bankReceiptNo: 'เลขที่ใบเสร็จธนาคาร',
  settlementCompany: 'หน่วยการชำระเงิน',
  solicitationType: 'ประเภทการรับสินค้า',
  writeOffPerson: 'ผู้ทำการตัดจ่าย',
  amountRange: 'ช่วงจำนวนเงิน',
  writeOffDate: 'วันที่ตัดจ่าย',
  RecheckDate: 'วันที่ตรวจสอบ',
  advanceMoneyOrNot: 'มีการจ่ายแทนหรือไม่',
  recheckOrNot: 'มีการตรวจสอบหรือไม่',
  proofOrNot: 'มีการสร้างหลักฐานหรือไม่',
  proofDate: 'วันที่ออกหลักฐาน',
  paymentType: 'ประเภทการชำระเงิน',
  prepaidOrNot: 'เป็นการชำระล่วงหน้าหรือไม่',
  theAmountOfWrittenOff: 'จำนวนเงินที่ตัดจ่ายแล้ว',
  balance: 'ยอดคงเหลือ',
  actualReceiptAmount: 'จำนวนเงินที่ได้รับจริง',
  actualPaymentAmount: 'จำนวนเงินที่จ่ายจริง',
  creator: 'ผู้สร้าง',
  recheck: 'ตรวจสอบ',
  invalid: 'ยกเลิก',
  invoicingInformation: 'ข้อมูลการออกใบแจ้งหนี้',
  unchecked: 'ยกเลิกการเลือก',
  writeOffCurrency: 'สกุลเงินในการตัดจ่าย',
  chargeOriginalCurrency: 'สกุลเงินเดิมของค่าใช้จ่าย',
  chargeOriginalAmount: 'จำนวนเงินเดิมของค่าใช้จ่าย',
  chargeOriginalExchangeRate: 'อัตราแลกเปลี่ยนเดิมของค่าใช้จ่าย',
  rmbAmount: 'เหรินหมินปี้ (จีน)',
  usdAmount: 'ดอลลาร์สหรัฐ',
  cancelRecheck: 'ยกเลิกการตรวจสอบ',
  editWriteOff: 'แก้ไขการตัดจ่าย',
  cancelWriteOff: 'เพิกถอนการตัดจ่าย',
  viewDetails: 'ดูรายละเอียด',
  exportExcel: 'ส่งออกตารางรายละเอียด',
  proof: 'หลักฐาน',
  refreshRate: 'รีเฟรชอัตราแลกเปลี่ยน',
  refreshActualReceiptAndPaymentAmount: 'รีเฟรชจำนวนเงินรับ/จ่ายจริง',
  writeOffType: 'ประเภทการตัดจ่าย',
  vesselVoyage: 'ชื่อเรือ/เที่ยวบิน',
  containerSizeAmount: 'ประเภทตู้/จำนวนตู้',
  monetaryEquivalent: 'จำนวนเงินที่คำนวณ',
  customerService: 'บริการลูกค้า',
  totalWriteOffs: 'รวมการตัดบัญชี',
  totalEquivalent: 'รวมการคำนวณ',
  exportToExcel: 'ส่งออก Excel',
  exportPDF: 'ส่งออก PDF',
  print: 'พิมพ์',
  close: 'ปิด',
  dayOfCreditTerm: 'ระยะเวลาบัญชี (วัน)',
  billPaymentNo: 'เลขที่แจ้งชำระเงิน',
  totalCurrency: 'รวมตามสกุลเงิน',
  rateBy: 'อัตราแลกเปลี่ยนตัดบัญชี',
  rateByInvoice: 'ตามอัตราแลกเปลี่ยนใบแจ้งหนี้',
  rateByAverage: 'ตามอัตราแลกเปลี่ยนเฉลี่ย',
  businessCreateDate: 'วันที่สร้างธุรกรรม',
  invoicingStatus: 'สถานะการออกใบแจ้งหนี้',
  searchReqCondition: 'ต้องเลือกเงื่อนไขการค้นหาอย่างน้อยหนึ่งรายการ',
  dateTo: 'ถึง',
  lockCheckBoxDate: 'ค้นหาข้อมูลเกินสองปี',
  queryLotsOfData: 'ค้นหาข้อมูลเกินสองปี',
  writeOffDateNotEmpty: 'วันที่ตัดบัญชีไม่สามารถเว้นว่างได้!',
  unlockWriteOffDateQuery: 'หากช่วงวันที่ตัดบัญชีที่เลือกมากกว่า 2 ปี จะส่งผลต่อความเร็วในการโหลดข้อมูล ยืนยันที่จะค้นหาข้อมูลเกินสองปีหรือไม่?',
  voucherNo: 'เลขที่เอกสาร',
  voucherCreateDate: 'วันที่สร้างเอกสาร',
  chargeSettleAccountsTo: 'หน่วยชำระค่าใช้จ่าย',
  update: 'อัปเดต',
  strip: 'รายการ',
  targetVoucherNo: 'เลขที่เอกสารของคู่กรณี',
  voucherDate: 'วันที่เอกสาร 2',
  sourceRateDiff: 'ส่วนต่างอัตราแลกเปลี่ยนสกุลเงินเดิม',
  warehouseNo: 'เลขที่เข้าโกดัง',
  userDefinedField1: 'ช่องกำหนดเอง 1',
  userDefinedField2: 'ช่องกำหนดเอง 2',
  userDefinedField3: 'ช่องกำหนดเอง 3',
  havingInvoiceingNoOrNot: 'มีเลขที่ใบแจ้งหนี้หรือไม่',
  selectActualReceiptAndPayment: 'เลือกรับจริงจ่ายจริง',
  noCurrencyRate: 'ไม่พบอัตราแลกเปลี่ยนสำหรับสกุลเงิน {0} โปรดบำรุงรักษาอัตราแลกเปลี่ยนที่เกี่ยวข้องทันที!',
  selectMethodOfPayment: 'โปรดเลือกวิธีการชำระเงิน',
  selectOurSideBank: 'โปรดเลือกธนาคารของเรา',
  rateByCharge: 'ตามอัตราแลกเปลี่ยนค่าใช้จ่าย',
  preExchangeDifference: 'ประมาณการส่วนต่างอัตราแลกเปลี่ยน',
  bankWaterNo: 'เลขที่ใบเสร็จธนาคาร',
  ReceivableSoldAmount: 'จำนวนเงินที่รับได้ที่ตัดบัญชีแล้ว',
  PayableSoldAmount: 'จำนวนเงินที่ต้องจ่ายที่ตัดบัญชีแล้ว',
  ActualAmountReceivable: 'จำนวนเงินที่รับได้จริง',
  ActualAmountPayable: 'จำนวนเงินที่จ่ายจริง',
  ChargeOriginTotalAmount: 'จำนวนเงินรวมเดิมของค่าใช้จ่าย',
  FinancialExpensesBeAllocated: 'มีการแบ่งสรรค่าใช้จ่ายทางการเงินหรือไม่',
  FinanceExpensesAllocation: 'การแบ่งสรรค่าใช้จ่ายทางการเงิน',
  ChargingDirection: 'ทิศทางการรับจ่าย',
  SelectChargeItem: 'กรุณาเลือกรายการค่าใช้จ่าย',
  SelectAccountObject: 'กรุณาเลือกหน่วยชำระเงิน',
  FinanceChargeShareJobTip: 'เมื่อติ๊กเลือก ค่าใช้จ่ายทางการเงินจะถูกแบ่งสรรอย่างเท่าๆกันไปยังธุรกรรมทั้งหมดที่อยู่ในรอบการตัดจ่ายนี้โดยอัตโนมัติ',
  NotSyncCannotModify: 'ข้อมูลที่ซิงค์กับคลาวด์แพลตฟอร์มแล้วไม่สามารถแก้ไขหรือยกเลิกได้!',
  invoiceTitle: 'Invoice Title',
  writeoffMatchStatus: 'Match Status',
  matchStatusUnmatched: 'Unmatched',
  matchStatusAuto: 'Auto Written Off',
  matchStatusManual: 'Manual Write-off',
  matchStatusNoNeed: 'No Need Write-off',
  matchStatusReason: 'Reason for Status Change',
  writeoffSeqNoSource: 'Serial No. Source',
  sourceImport: 'Import',
  sourceSystem: 'System',
  modifyMatchStatus: 'Modify Match Status',
  modifyStatus: 'Modify Status',
  modifyReason: 'Reason',
  confirmModify: 'Confirm',
  modifySuccess: 'Successfully modified {0} records',
  lockedCannotModify: 'Locked, cannot modify',
  containsLockedStatus: 'Contains locked status, please select unmatched records',
  pleaseSelectUnmatched: 'Please select unmatched records',
  selectAtLeastOne: 'Please select at least one record'
}
